export default "__VITE_ASSET__cn0O94mN__"